import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { Customer } from '../models/customer';
import { CustomerService } from '../services/customer.service';
import { MessageService } from '../../shared/message.service';
import { Subscription } from 'rxjs';
import { MessageType } from '../../shared/messageType';
import { AlertType, Alert } from '../../shared/alert.model';
import { getAlertMessage } from '../../shared/api-loaders';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import {SecurityService} from '../../shared/security.service';

@Component({
    selector: 're-customer-feature-customer-list',
    templateUrl: './customer-list.component.html',
    styleUrls: ['./customer-list.component.scss'],
    standalone: false
})
export class CustomerListComponent implements OnInit, OnDestroy {
  dataTable: DataTables.Api;
  ngOnDestroy(): void {
    delete window["currentComponent"];
    this.messageSubscription.unsubscribe();
    this.dataTable.destroy();
    }

  //customers: Customer[];
  loading: boolean;
  messageSubscription: Subscription;
  alert: Alert;
  newCustomers: Customer[] = [];
  isReadOnlyUser: boolean;

  constructor(
    private customerService: CustomerService,
    private messageService: MessageService,
    private router: Router,
    private ngZone: NgZone,
    private datepipe: DatePipe,
    private securityService: SecurityService
  ) {
    this.messageSubscription = this.messageService.get().subscribe(message => {
      if (message.type == MessageType.CustomerCreated) {
        this.alert = { type: AlertType.SUCCESS, message: `Customer ${message.data} has been created successfully`  };
        this.clearAlerts();
      }
    })

  }
  clearAlerts() {
    setTimeout(() => this.alert = null, 5000);
  }

  async ngOnInit() {
    this.isReadOnlyUser = await this.securityService.isThisReadOnlyUser();
    window["currentComponent"] = this;
    this.populateDataTable();
    this.getCustomers();
  }

  getCustomers(): void {
    this.loading = true;
    this.customerService.getCustomersByStack()
      .subscribe(customers => {
        //this.customers = customers;
          this.newCustomers = customers;
          this.loading = false;
          this.dataTable.clear();
          this.dataTable.rows.add(this.newCustomers);
          this.dataTable.draw();
          },
      error => {
        this.alert = getAlertMessage(error);
        this.loading = false;
      });
  }

  navigateToRoute(url: string) {
    this.ngZone.run(() => {
      this.router.navigateByUrl(url);
    })
  }

  deleteCustomer(id: number) {
    this.customerService.deleteCustomer(id)
      .subscribe(
        res => {
          setTimeout(() => {
            this.getCustomers();
          })
        },
        error => {
          this.alert = getAlertMessage(error);
        });
  }

  populateDataTable() {
    this.dataTable = $('#customerSearchList').DataTable({
      dom:
        '<"row"<"col"f>>' +
        '<"row"<"col-sm-12"tr>>' +
        '<"row d-none d-sm-flex"<"col-sm-12"<"float-right"p><"float-right neo-dt-l"l>>>' +
        '<"row d-flex d-sm-none"<"col-sm-6"l><"col-sm-6"p>>' +
        '<"row float-right d-none d-sm-flex"<"col-sm-12"<"float-right neo-dt-i"i>>>' +
        '<"row d-flex d-sm-none"<"col-sm-12"i>>',
      pagingType: 'full_numbers',
      pageLength: 50,
      lengthMenu: [[25, 50, 100, 250, 500, -1], [25, 50, 100, 250, 500, "All"]],
      ordering: true,
      searching: true,
      paging: true,
      info: true,
      serverSide: false,
      autoWidth: true,
      columnDefs: [

        { targets: 4, type: 'date' }

      ],
      columns: [
        {
          title: 'ID', render: (data: any, type: any, c: Customer) => {
            return `${c.id}`;
          }
        },
        {
          title: 'Customer Name',render: (data: any, type: any, c: Customer) => {
            return `<a href='javascript:currentComponent.navigateToRoute("/ect/customers/detail/${c.id}")'>${c.accountName}</a>`;
          }
        },
        {
          title: 'CRM ID', render: (data: any, type: any, c: Customer) => {
            return `${c.accountId}`;
          }
        },
        {
          title: 'GUID', render: (data: any, type: any, c: Customer) => {
            return c.guid ? `${c.guid}` : '';
          }
        },
        {
          title: 'Created By', render: (data: any, type: any, c: Customer) => {
            return `${c.createdBy}`;
          }
        },
        {
          title: 'Created Date', render: (data: any, type: any, c: Customer) =>{
            return this.datepipe.transform(c.createdDate, 'medium');
          }
        },
        {
          title: 'Actions', className: 'actionsCell',render: (data: any, type: any, c: Customer) => {
            if (!this.isReadOnlyUser){
              let html  = `<a href="javascript:" onclick="currentComponent.deleteCustomer(${c.id})">Delete</a>`;
              return html;
            } else
            {let html  = `<a href="javascript:" disabled="true">Delete</a>`;
              return html;}

          }
        },
      ]
    });
    new $.fn.dataTable['FixedHeader'](this.dataTable);
    $('.dataTables_filter input[type="search"]').
    css({'width':'375px','display':'inline-block'});
    //this.getCustomers();
  }

}
